import { AuthComponent } from './components/auth/auth.component';
import { RouterModule, Routes } from '@angular/router';
import { NotLoggedGuard } from './guards/not-logged.guard';
import { LoggedRouteGuard } from './guards/logged-route.guard';
import { NgModule } from '@angular/core';
import { environment } from '../environments/environment.prod';
import { PlanningComponent } from './components/planning/planning.component';
import { AppBaseComponent } from './app-base/app-base.component';
import { ChooseClubComponent } from './components/choose-club/choose-club.component';
import { HighlightsComponent } from './components/highlights/highlights.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { CrashComponent } from './components/crash/crash.component';
import { DisconnectedComponent } from './components/disconnected/disconnected.component';

const tvScreen = window.app.tvScreen;

const defaultRoutes = [
     {
          path: '',
          component: AuthComponent,
          pathMatch: 'full',
          canActivate: [NotLoggedGuard],
     },
     {
          path: 'choose-centre',
          component: ChooseClubComponent,
          pathMatch: 'full',
          canActivate: [NotLoggedGuard],
     },
     {
          path: 'crash',
          component: CrashComponent,
          pathMatch: 'full',
     },
     {
          path: 'disconnected',
          component: DisconnectedComponent,
     },
     {
          path: 'app',
          component: AppBaseComponent,
          // canActivate: [LoggedRouteGuard],
          canActivateChild: [LoggedRouteGuard] /*AppBootstrapSetupGuard*/,
          children: [
               { path: '', component: HighlightsComponent },
               { path: 'planning', component: PlanningComponent },
          ],
     },
     { path: '**', component: NotFoundComponent },
];

const tvScreenRoutes = [
     {
          path: '',
          redirectTo: 'app',
          pathMatch: 'full',
     },
     {
          path: 'app',
          component: AppBaseComponent,
          // canActivate: [LoggedRouteGuard],
          canActivateChild: [] /*AppBootstrapSetupGuard*/,
          children: [{ path: '', component: PlanningComponent }],
     },
     { path: '**', component: NotFoundComponent },
];

export const ROUTES: Routes = [
     /**
      * Load routes differently
      */
     ...(tvScreen ? tvScreenRoutes : defaultRoutes),
];

@NgModule({
     imports: [
          RouterModule.forRoot(ROUTES, {
               enableTracing: !environment.production,
               useHash: true,
          }),
     ],
     exports: [RouterModule],
     providers: [],
})
export class AppRoutingModule {}
